import { useQuery } from '@tanstack/react-query';
import { customerService, type CustomerFilters } from '../api/services/customerService';

export function useCustomerQuery(filters: CustomerFilters) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['customers', filters],
    queryFn: async () => {
      try {
        const customers = await customerService.getCustomers(filters);
        console.log('[useCustomerQuery] Successfully fetched customers:', customers);
        return customers;
      } catch (error) {
        console.error('[useCustomerQuery] Error fetching customers:', error);
        throw error;
      }
    },
    retry: false // Don't retry on error
  });

  if (error) {
    console.error('[useCustomerQuery] Query error:', error);
  }

  return {
    customers: data ?? [], // Use nullish coalescing to handle undefined
    isLoading,
    error,
    refetch,
  };
}
